import { jsx } from 'react/jsx-runtime';
import { useContext, createContext, useMemo } from 'react';
var SubMenuContext = /*#__PURE__*/createContext(null);

var SubMenuMenuProvider = function SubMenuMenuProvider(_ref) {
  var children = _ref.children,
      isSubMenuOpen = _ref.isSubMenuOpen,
      setIsSubMenuOpen = _ref.setIsSubMenuOpen;
  var value = useMemo(function () {
    return {
      isSubMenuOpen: isSubMenuOpen,
      setIsSubMenuOpen: setIsSubMenuOpen
    };
  }, [isSubMenuOpen, setIsSubMenuOpen]);
  return jsx(SubMenuContext.Provider, {
    value: value,
    children: children
  });
};

var useSubMenu = function useSubMenu() {
  var context = useContext(SubMenuContext);

  if (context === null) {
    throw new Error('useSubMenu must be used within a menu .Root component');
  }

  return context;
};

export { SubMenuMenuProvider, useSubMenu };